.toggle {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  padding: 8px 16px 8px 8px;
  border-radius: 999px;
  border: 1px solid rgb(255 138 31 / 0.4);
  background: rgb(255 138 31 / 0.08);
  color: #ffd0a8;
  font-weight: 600;
  cursor: pointer;
  transition:
    background 0.25s,
    box-shadow 0.25s;
}

.toggle:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.mark {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  display: grid;
  place-items: center;
  background: rgb(255 138 31 / 0.25);
  color: var(--color-uncertain);
  font-weight: 900;
  transition:
    background 0.25s,
    color 0.25s;
}

.toggle[aria-pressed='true'] {
  background: rgb(255 138 31 / 0.2);
  border-color: var(--color-uncertain);
  box-shadow: 0 0 22px var(--color-uncertain-glow);
  animation: glow 2.2s ease-in-out infinite;
}

.toggle[aria-pressed='true'] .mark {
  background: var(--color-uncertain);
  color: #1d0d00;
}

@keyframes glow {
  0%,
  100% {
    box-shadow: 0 0 10px var(--color-uncertain-glow);
  }
  50% {
    box-shadow: 0 0 28px var(--color-uncertain-glow);
  }
}
